<template>
  <div>
    <div class="certificate_qr_code">
      <vue-qr :margin="margin_size"
              colorDark="#0f6ea3"
              colorLight="#FFF"
              :logoSrc="qrImageUrl"
              :text="JSON.stringify({'code':this.code,'type':this.type}) "
              :size="size"></vue-qr>

      <div v-if="showTitle"
           class="certificate_qr_infor">{{introduce}} </div>
    </div>
  </div>
</template>

<script>
import vueQr from 'vue-qr'
export default {
  name: 'show-qr-code',
  components: {
    vueQr,
  },
  data() {
    return {
      qrCode: '',
      qrImageUrl: require('../../../assets/img/TRAVER-logo.jpg'),
      margin_size: this.marginSize,
    }
  },
  props: {
    code: '',
    type: '',
    size: null,
    marginSize: {
      type: Number,
      default: 15,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    introduce: {
      type: String,
      default: '扫码查看内容',
    },
  },
}
</script>

<style>
/* 二维码 */
.certificate_qr_code {
  text-align: center;
  /* position: absolute; */
  color: #0f6ea3;
  font-weight: bolder;
  font: 1rem;
}

.certificate_qr_infor {
  /* position: absolute; */
  padding: 3px;
  margin: auto 0;
  /* width: 95%; */
  background-color: #0f6ea3;
  /* border-radius: 10px; */
  color: white;
}
</style>